export default __webpack_public_path__ + "static/media/640_dummy2016-musikschule01-de.a4e685bc.png";